<div id="snackbar" [class.show]='appService.showSnackbar'>{{appService.snackbarText | translate}}</div>